import { EduPaths } from "@/modules/edu"

export const generateEduPath = (path: string) => {
  return `${EduPaths.EDU.replace("*", "")}${path}`
}
